module.exports = __webpack_public_path__ + "static/014-5de54249ed50b8e61468c6936fbbcbdd.jpg";